<template>
  <div class="modal-content modal-lg" style="border-radius: 1rem">
    <div class="modal-header p-b-0">
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
    </div>

    <div class="modal-body p-b-0 p-t-0 text-center">
      <header>
        <h2 class="text-center m-b-30">
          Avaliações de <strong>{{ user.full_name }}</strong>
        </h2>
      </header>

      <div class="row m-t-10 m-b-10 rating-row" v-for="rating in ratings" :key="rating.id">
        <div class="col-xs-12 box">
          <div class="rating-header">
            <div class="d-flex align-center">
              <img :src="rating.rating_user.photo_url" alt="profile-image" class="img-circle img-avatar" />
              <div class="d-flex flex-column align-start p-l-8">
                <span class="text-user">{{ rating.rating_user.full_name }}</span>
                <span class="text-data"><i class="fa fa-calendar m-r-8"></i>{{ rating.created_at }}</span>
              </div>
            </div>
            <div v-if="rating.can_reply && !rating.reply" class="reply-button-container">
              <button type="button" class="text-subject btn btn-link" @click="openReplyModal(rating)">
                <i class="fa fa-reply m-r-2"></i>
                <span class="reply-text">Responder</span>
              </button>
            </div>
          </div>

          <div class="rating-body">
            <div class="text-left m-b-20">
              <p class="text-subject" v-if="user.current_view === 'roommate'">{{ rating.comment_user }}</p>
              <p class="text-subject" v-else>{{ rating.comment_property_ad || rating.comment_user }}</p>
            </div>
            <div class="d-flex align-center justify-start m-b-10">
              <div class="d-flex align-center">
                <vue-star-rating v-model="rating.rating" name="rating" :increment="0.5" border-color="#cbb956" :rounded-corners="true" :star-size="20" :read-only="true" :show-rating="false"></vue-star-rating>
                <span class="text-rating">{{ Number(rating.rating).toFixed(1) }}/5.0</span>
              </div>
              <div class="divider"></div>
              <div class="d-flex align-center">
                <img v-if="rating.rental.confirmed_by_host_at" src="/images/house.svg" alt="house" class="confirmation-icon" />
                <img v-else src="/images/close.svg" alt="close" class="confirmation-icon" />
                <span class="text-icon">{{ rating.rental.confirmed_by_host_at ? "Aluguel confirmado" : "Aluguel não confirmado" }} </span>
              </div>
            </div>
          </div>

          <div v-if="rating.reply" class="reply-body m-t-15">
            <div class="reply-header text-subject">
              <i class="fa fa-comment m-r-4" aria-hidden="true"></i>
              Resposta de {{ user.full_name }}:
            </div>
            <p class="text-subject reply-text-content">
              {{ rating.reply.reply }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueStarRating from "../../../../../../legacy/node_modules/vue-star-rating";
import replyRating from "./reply-rating.vue";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    ratings: {
      type: Array,
      required: true,
    },
  },
  components: { VueStarRating },

  methods: {
    openReplyModal(rating) {
      EventBus.$emit('open-modal', replyRating, {
        rating: rating,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f8f8f8;
  padding: 12px;
  border-radius: 10px;
}

.text-subject {
  font-style: italic;
  color: #313a46;
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 0;
}

.text-rating {
  font-size: 1.5rem;
  font-weight: 700;
  padding: 0px 1rem;
  letter-spacing: 0.125rem;
  position: relative;
  top: -2px;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-start {
  justify-content: flex-start;
  > .d-flex {
    flex-shrink: 1;
    min-width: 0;
  }
}

.flex-column {
  flex-direction: column;
}

.w-10 {
  width: 10rem;
}

.p-0-4 {
  padding: 0px 4px;
}

.p-l-8 {
  padding-left: 8px;
}

.m-b-20 {
  margin-bottom: 20px;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-r-2 {
  margin-right: 2px;
}

.m-r-4 {
  margin-right: 4px;
}

.m-r-8 {
  margin-right: 8px;
}

.m-t-15 {
  margin-top: 15px;
}

.confirmation-icon {
  margin: 0 1rem;
}

.text-icon {
  font-size: 14px;
}

.align-start {
  align-items: flex-start;
}

.text-user {
  font-size: 14px;
  font-weight: 600;
  color: #313a46;
}

.text-data {
  font-size: 12px;
}

.img-avatar {
  width: 50px;
  height: 50px;
}

.rating-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.rating-body {
  padding-top: 10px;
}

.reply-body {
  background-color: #f9f9f9;
  padding: 10px 15px;
  border-left: 3px solid #d1d5db;
  margin-left: 15px;
  text-align: left;

  i {
    color: #d5d4d4;
  }
}

.reply-header {
  font-weight: 600;
  margin-bottom: 4px;
}

.divider {
  width: 1px;
  background-color: #e0e0e0;
  align-self: stretch;
  min-height: 20px;
  margin: 0 0.5rem;
}

.reply-button-container {
  margin-left: auto;
}

@media (max-width: 768px) {
  .confirmation-icon {
    margin: 0;
    margin-right: 0.5rem;
  }
}
</style>
